var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-biography cw-block-biography-goals",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          closeEdit: _vm.initCurrentData,
          showEdit: _vm.setShowEdit,
          storeEdit: _vm.storeBlock,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-biography-content",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cw-block-biography-type",
                          class:
                            "cw-block-biography-goals-type-" +
                            _vm.currentData.type,
                        },
                        [_c("h2", [_vm._v(_vm._s(_vm.goalTypeName))])]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "cw-block-biography-details formatted-content ck-content",
                        domProps: {
                          innerHTML: _vm._s(_vm.currentData.description),
                        },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                        },
                        [
                          _c(
                            "label",
                            {
                              attrs: {
                                for: "type",
                              },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("Ziel")) +
                                  "\n                    "
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentData.type,
                                      expression: "currentData.type",
                                    },
                                  ],
                                  staticClass: "type",
                                  attrs: {
                                    name: "type",
                                  },
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.currentData,
                                        "type",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "personal",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$gettext("Persönliches Ziel")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "school",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$gettext("Schulisches Ziel"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "academic",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$gettext("Akademisches Ziel")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "professional",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$gettext("Berufliches Ziel"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "label-text",
                            },
                            [
                              _vm._v(
                                "\n                   " +
                                  _vm._s(_vm.$gettext("Beschreibung")) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("studip-wysiwyg", {
                            model: {
                              value: _vm.currentData.description,
                              callback: function callback($$v) {
                                _vm.$set(_vm.currentData, "description", $$v)
                              },
                              expression: "currentData.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _vm._v(_vm._s(_vm.$gettext("Informationen zum Ziele-Block"))),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }